import { useQuery } from '@tanstack/react-query';

import { operations } from '@luxuryescapes/contract-svc-promo';

import { getInternalPromo } from '~/services/PromoService';

export const promoQueryKeys = {
  all: ['promos'] as const,
  detail: (brand: string, codeName?: string) => [...promoQueryKeys.all, 'detail', brand, codeName] as const,
};

export function useGetPromo({
  codeName,
  brand,
  enabled = true,
}: {
  codeName?: string;
  brand: string;
  enabled?: boolean;
}) {
  return useQuery<operations['getPromoCodeByCode']['responses']['200']['content']['application/json']>({
    queryKey: promoQueryKeys.detail(brand, codeName),
    queryFn: () => getInternalPromo({ code_name: codeName, brand }),
    enabled: enabled && Boolean(codeName),
  });
}
